module.exports = __webpack_public_path__ + "img/expeditionary-stage_4.2.9701ee02.jpg";